/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, func, string, bool,
} from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useDispatch, useSelector } from 'react-redux';
import convertAlphaDecToHex from '../../../../../../../helpers/contentstack/convertAlphaDecToHex';
import ZipInput from '../../../../../../EnterpriseDesignSystem/Inputs/ZipInput/ZipInput';
import Select from '../../../../../../EnterpriseDesignSystem/Select/Select';
import StyledButton from '../../../../../../EnterpriseDesignSystem/Button/StyledButton';
import classes from './GiftFinderEdsLogin.module.css';
import GiftFinderLoginPrompt from '../GiftFinderLoginPrompt';
import { clearUserSubmittedProductFilterZipcode, clearValidatedZipcode } from '../../../../../../../../state/ducks/App/App-Actions';

const GiftFinderEdsLogin = ({
    data, handleSubmitEds, userSubmittedZip, handleChange, onSubmitCheck,
    zip, validatedZip, setSelectedOccasion, buttonStyle, giftFinderLoginEnabled,
}) => {
    useStyles(classes);
    const dispatch = useDispatch();
    const giftFinderBgColor = data?.background_color || '';
    const giftFinderBgColorOpacity = data?.background_color_opacity || 1;
    const convertedGiftFinderBgColor = convertAlphaDecToHex(giftFinderBgColor, giftFinderBgColorOpacity);
    const giftFinderBodyTextColor = data?.text_color || '';
    const sectionTitle = data?.title_name || '';
    const edsZipLabel = data?.gift_finder_blocks?.[0]?.delivery_zip_code?.eds_label || 'Delivery zip code';
    const occasionTitle = data?.gift_finder_blocks?.[1]?.occasion?.title || '';
    const occasion_option_group = data?.gift_finder_blocks?.[1]?.occasion?.occasion_option_group || [];
    const giftFinderWidth = `${classes.giftFinderEdsInnerContainer} ${data?.has_full_width && classes.giftFinderEdsInnerContainerFullWidth}`;
    const getGiftFinderWrapperClass = (has_negative_margin_top, has_full_width) => {
        const baseClass = classes.giftFinderEdsFormWrapper;

        if (has_negative_margin_top) {
            return baseClass;
        }
        // used for AB TESTING - full width banner vs decouple
        const marginClassOverride = has_full_width
            ? classes.giftFinderNoMarginTop
            : classes.giftFinderNoNegativeTopMargin;

        return `${baseClass} ${marginClassOverride}`;
    };
    const giftFinderWrapperClassName = getGiftFinderWrapperClass(data?.has_negative_margin_top, data?.has_full_width);

    return (
        <form className={giftFinderWrapperClassName} onSubmit={handleSubmitEds} id="gf-eds">
            <div className={giftFinderWidth} style={{ backgroundColor: convertedGiftFinderBgColor }}>
                <div className={classes.giftFinderEdsSectionTitle} style={{ color: giftFinderBodyTextColor }}>
                    {sectionTitle || 'Find the Perfect Gift'}
                </div>
                <div className={classes.giftFindeEdsRoot}>
                    <GiftFinderLoginPrompt textColor={buttonStyle.backgroundColor} handleChange={handleChange} giftFinderLoginEnabled={giftFinderLoginEnabled} />
                    <div className={classes.giftFinderEdsZipWidthContainer}>
                        <ZipInput
                            id="zipcode-native-label-placeholder"
                            dataTest="hp-zipcode-native-label-placeholder"
                            label={edsZipLabel}
                            name="zipcode"
                            type="text"
                            defaultValue={userSubmittedZip}
                            value={zip}
                            handleChange={(e) => {
                                handleChange('zip')(e);
                                if (!e.target.value?.length) {
                                    // reset the zip is valid flag in redux if zip is not characters.
                                    dispatch(clearUserSubmittedProductFilterZipcode());
                                    dispatch(clearValidatedZipcode());
                                }
                            }}
                            onSubmitCheck={onSubmitCheck}
                        />
                        {onSubmitCheck && (validatedZip !== zip)
                        && (
                            <div className={classes.zipInputError}>
                                Enter a valid ZIP code
                            </div>
                        )}
                    </div>
                    <div className={classes.giftFinderEdsSelectWidthContainer}>
                        <Select
                            label={occasionTitle}
                            id="occasion-native-label-placeholder"
                            dataTestId="4810-hp-occasion-native-label-placeholder"
                            name="occasion"
                            dropDownList={occasion_option_group}
                            handleChange={(e) => {
                                setSelectedOccasion(e.target.value);
                            }}
                        />
                    </div>
                    <div className={classes.giftFinderEdsButtonWidthContainer}>
                        <StyledButton
                            label={data?.cta_copy || 'Find a Gift Now'}
                            variant="light"
                            size="lg"
                            type="submit"
                            attributes={{
                                style: {
                                    border: `1px solid ${buttonStyle.backgroundColor}`,
                                    backgroundColor: buttonStyle.backgroundColor,
                                    color: buttonStyle.color,
                                    height: '56px',
                                    textTransform: 'none',
                                },
                                id: 'fagf-btn',
                                'data-test-id': 'fagf-btn',
                            }}
                        />
                    </div>
                </div>
            </div>
        </form>
    );
};

GiftFinderEdsLogin.propTypes = {
    buttonStyle: object,
    data: object.isRequired,
    onSubmitCheck: func.isRequired,
    handleChange: func.isRequired,
    handleSubmitEds: func.isRequired,
    validatedZip: string.isRequired,
    setSelectedOccasion: func.isRequired,
    userSubmittedZip: string.isRequired,
    zip: string,
    giftFinderLoginEnabled: bool,
};

GiftFinderEdsLogin.defaultProps = {
    zip: '',
    buttonStyle: {},
    giftFinderLoginEnabled: false,
};

export default GiftFinderEdsLogin;
